
import SignUpStepsCard from "../SignUpStepsCard";
import {signUpItem} from "../../../pages/signUp/SignUp";
import style from "./SignUpSidebar.module.scss"
import {useEffect, useState} from "react";
import {RouteInfo} from "../../../route/RouteHelper";
import {RaikoLabel} from "@moeindal/base-raiko-panel-components";

export default function SignUpSidebar() {
    const currentPageUrl = window.location.pathname
    const [activeState, setActiveState] = useState(0)

    function checkedUrl() {
        switch (currentPageUrl) {
            case RouteInfo.SignUpIntro.globalUrl:
                setActiveState(0)
                break;
            case RouteInfo.SignUpSellerType.globalUrl:
                setActiveState(1)
                break;
            case RouteInfo.LegalPerson.globalUrl:
                setActiveState(2)
                break;
        }

    }

    useEffect(
        checkedUrl
        , [currentPageUrl])

    return (
        <div className={style.signUpSidebar}>
            <RaikoLabel text={"برای تکمیل فرآیند ثبت نام،مراحل زیر را تکمیل نمایید"}/>
            <div className={style.signUpSidebarWrapper}>
                {
                    signUpItem.map((item, index) => {
                        return <SignUpStepsCard
                            key={index}
                            icon={item.icon}
                            title={item.title}
                            subTitle={item.subTitle}
                            currentPage={currentPageUrl === item.url}
                            currentStep={activeState >= index}/>
                    })
                }
            </div>

        </div>
    )
}